import { useState } from "react";
import { useLocation } from "wouter";
import type { CCAMActe } from "cadendar-shared";
import { CCAMBrowserModal } from "../../../components/CCAM/CCAMBrowserModal";

const CCAMBrowserTestPage = () => {
  const [, navigate] = useLocation();
  const [selectedActe, setSelectedActe] = useState<CCAMActe | null>(null);

  const handleClose = () => {
    navigate("/");
  };

  const handleSelectActe = (acte: CCAMActe) => {
    setSelectedActe(acte);
  };

  return (
    <>
      <CCAMBrowserModal
        isOpen={true}
        onClose={handleClose}
        onSelectActe={handleSelectActe}
        title="Browser CCAM (test)"
        autoCloseOnSelect={false}
      />

      {selectedActe ? (
        <div className="fixed bottom-4 right-4 z-60 rounded-lg bg-white p-3 shadow-lg border border-gray-200">
          <p className="text-xs text-gray-500">Dernier acte sélectionné</p>
          <p className="font-mono text-sm text-blue-700">{selectedActe.code}</p>
          <p className="text-sm text-gray-900 max-w-md">
            {selectedActe.libelle}
          </p>
        </div>
      ) : null}
    </>
  );
};

export default CCAMBrowserTestPage;
